module.exports = __webpack_public_path__ + "static/media/fund.a66e028c.svg";